<template>
  <v-app-bar app height="100" clipped-right>
    <LinkLogo />

    <v-toolbar-title class="primary--text">{{ $t("boutique.titre") }}</v-toolbar-title>
    <v-spacer />
    <ChangeLocale class="mr-3" />

    <v-menu offset-y :close-on-content-click="false" v-model="loginMenu">
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" color="primary" :text="loggedIn" large>
          {{ loggedIn ? prenomNom : $t("formulaireAuth.connexion") }}
        </v-btn>
      </template>
      <v-sheet class="pa-4 pa-md-8" width="350">
        <Account />
      </v-sheet>
    </v-menu>
    <v-badge v-show="$route.name !== 'Caisse'" overlap :content="panier.length" :value="panier.length" color="black" class="mx-3">
      <v-btn icon @click="TOGGLE_PANIER" large color="black">
        <v-icon>mdi-cart</v-icon>
      </v-btn>
    </v-badge>
  </v-app-bar>
</template>

<script>
import LinkLogo from "@/components/common/LinkLogo"
import Account from "@/components/common/Account"
import ChangeLocale from "@/components/common/ChangeLocale"
import { mapGetters, mapMutations } from "vuex"
export default {
  mixins: [],
  data() {
    return {
      loginMenu: false
    }
  },
  components: {
    LinkLogo,
    Account,
    ChangeLocale
  },
  methods: {
    ...mapMutations(["TOGGLE_PANIER"])
  },
  computed: {
    ...mapGetters(["panier", "loggedIn", "prenomNom"])
  }
}
</script>

<style>
</style>